import { Alert } from 'react-bootstrap';
import React, { ReactNode } from 'react';

interface Props {
    children?: ReactNode | string;
}

const Notice: React.FC<Props> = ({ children }) => {
    return (
        <Alert variant="warning" className={'pt-2 pb-1'}>
            <>
                <i
                    role="img"
                    aria-label={'user notice'}
                    className="bi bi-info-circle mt-0 mb-2 flex-nowrap"
                ></i>
                {children}
            </>
        </Alert>
    );
};

export default Notice;
